import React, { ReactNode } from "react";
import UIButton from "./Button";

interface UIPopupProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children?: ReactNode;
  primaryButton?: {
    text: string;
    onClick: () => void;
    backgroundColor: string;
    textColor?: string;
  };
  secondaryButton?: {
    text: string;
    onClick: () => void;
    backgroundColor: string;
    textColor?: string;
    isShow?: boolean;
  };
}

const UIPopup: React.FC<UIPopupProps> = ({
  isOpen,
  onClose,
  title,
  children,
  primaryButton = {
    text: "Confirm",
    onClick: () => {},
    backgroundColor: "btn-color",
    textColor: "text-white",
  },
  secondaryButton = {
    text: "Cancel",
    onClick: () => {},
    backgroundColor: "btn-disabled",
    textColor: "text-white",
  },
}) => {
  if (!isOpen) return null;

  return (
    <div className="absolute top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center p-4">
      <div className="bg-[#212226] rounded-lg p-6 w-[90%] max-w-md relative">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold text-white">{title}</h2>
          <button
            onClick={onClose}
            className="p-1 hover:opacity-80 transition-opacity">
            <img
              src="/assets/images/icon-close.svg"
              alt="close"
              className="w-6 h-6"
            />
          </button>
        </div>

        <div className="text-white mb-6">{children}</div>

        <div className="flex gap-4">
          {secondaryButton.isShow !== false && (
            <UIButton
              text={secondaryButton.text}
              textColor={secondaryButton.textColor || "text-white"}
              onClick={secondaryButton.onClick}
              classButton="flex-1"
              backgroundColor={secondaryButton.backgroundColor}
            />
          )}
          <UIButton
            text={primaryButton.text}
            textColor={primaryButton.textColor || "text-white"}
            onClick={primaryButton.onClick}
            classButton="flex-1"
            backgroundColor={primaryButton.backgroundColor}
          />
        </div>
      </div>
    </div>
  );
};

export default UIPopup;
